module.exports = "<div class=\"container my-5\">\n  <div class=\"map-area text-center\">\n    <p>Map Area</p>\n  </div>\n</div>"